var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('Biaodan',{model:{value:(_vm.datalist),callback:function ($$v) {_vm.datalist=$$v},expression:"datalist"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }